export default class TaskDetailController {
    /**
     * constructor
     * @param  {Object} $scope
     * @param  {Object} $stateParams
     * @param  {Object} ApiTasks
     */

    constructor(
        $scope,
        $rootScope,
        $state,
        $stateParams,
        ApiTasks,
        ApiEmail,
        $ionicLoading,
        $ionicPopup,
        $filter,
        FileSaver,
        $cordovaToast,
        TaskMutationTrackingService
    ) {
        this.$ionicLoading = $ionicLoading;
        this.$ionicPopup = $ionicPopup;
        this.$filter = $filter;
        this.ApiTasks = ApiTasks;
        this.ApiEmail = ApiEmail;
        this.$state = $state;
        this.task = {};
        this.taskId = $stateParams.taskId;
        this.FileSaver = FileSaver;
        this.$cordovaToast = $cordovaToast;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.tasksCount = $stateParams.tasksCount;
        this.TaskMutationTrackingService = TaskMutationTrackingService;
    }

    init() {
        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>',
            duration: 10000,
        });
        // Load task from database
        this.ApiTasks.getTask(this.taskId).then((res) => {
            if (typeof res != 'undefined') {
                this.task = res;
                if (this.task.emailInfo) {
                    this.$rootScope.pageTitle = 'EMAIL_DETAIL';
                }
                this.$ionicLoading.hide();
            } else {
                this.$ionicLoading.hide();
            }
        });
    }

    onEditClick() {
        if (this.$stateParams.callingPage && this.$stateParams.referenceId) {
            this.$state.go('taskEdit', {
                taskId: this.taskId,
                callingPage: this.$stateParams.callingPage,
                referenceId: this.$stateParams.referenceId,
                tasksCount: this.tasksCount,
            });
        } else {
            this.$state.go('taskEdit', {
                taskId: this.taskId,
                tasksCount: this.tasksCount,
            });
        }
    }

    // works for android
    downloadAttachment(id) {
        this.ApiEmail.getAttachment(id).then((res) => {
            var binary = atob(res.binaryFile64);
            var array = new Uint8Array(binary.length);
            let name = res.name;
            for (var i = 0; i < binary.length; i++) {
                array[i] = binary.charCodeAt(i);
            }
            var blob = new Blob([array], { type: res.type });
            if (!ionic.Platform.isWebView() || ionic.Platform.isIOS()) {
                this.FileSaver.saveAs(blob, res.name);
                this.$ionicLoading.hide();
            } else {
                let self = this;
                // In iOS the files will be stored private (within the app) thats why we use the browser functionality above for ios
                let filePath = ionic.Platform.isAndroid()
                    ? cordova.file.externalRootDirectory + 'Download/'
                    : cordova.file.documentsDirectory;
                window.resolveLocalFileSystemURL(
                    filePath,
                    (dir) => {
                        dir.getFile(
                            name,
                            { create: true },
                            (file) => {
                                if (!file) {
                                    $ionicLoading.hide();
                                    $cordovaToast.showLongBottom(
                                        name +
                                            ' could not be saved: no access to file'
                                    );
                                }

                                file.createWriter(
                                    (fileWriter) => {
                                        fileWriter.seek(fileWriter.length);
                                        fileWriter.write(blob);
                                        $ionicLoading.hide();
                                        $cordovaToast.showLongBottom(
                                            name + ' saved to ' + filePath
                                        );
                                    },
                                    (e) => {
                                        $ionicLoading.hide();
                                        $cordovaToast.showLongBottom(
                                            name +
                                                ' could not be saved: ' +
                                                e.toString()
                                        );
                                    }
                                );
                            },
                            () => {
                                $ionicLoading.hide();
                                $cordovaToast.showLongBottom(
                                    name + ' could not be saved'
                                );
                            }
                        );
                    },
                    (e) => {
                        $ionicLoading.hide();
                        $cordovaToast.showLongBottom(
                            name + ' could not be saved: ' + e.toString()
                        );
                    }
                );
            }
        });
    }

    resendMail(taskId) {
        let dialogResult = this.$ionicPopup.confirm({
            title: this.$filter('translate')('RESEND_EMAIL_PROMPT_TITLE'),
            template: this.$filter('translate')('RESEND_EMAIL_PROMPT_CONTENT'),
        });

        dialogResult.then((res) => {
            if (res) {
                this.ApiEmail.resendMail(taskId).then((result) => {
                    if (result !== undefined) {
                        this.$ionicPopup.alert({
                            title: '<b>Email sent</b>',
                            template: 'Your email has been successfully sent',
                            okType: 'button-picton-blue',
                        });
                    }
                });
            }
        });
    }

    promptTaskDelete($event) {
        $event.preventDefault();
        let dialogResult = this.$ionicPopup.confirm({
            title: this.$filter('translate')('DELETE_TASK'),
            template: this.$filter('translate')('DELETE_TASK_PROMPT'),
        });

        dialogResult.then((res) => {
            if (res) {
                this.deleteTask(this.task);
            }
        });
    }

    deleteTask(task) {
        const taskCalendar = task.task;
        this.ApiTasks.deleteTask(task.task.taskId).then((res) => {
            if (res === null) {
                this.deleteEvent(task);
                this.redirectToCallingPage();
            }
        });
    }

    redirectToCallingPage() {
        // let callingPage = this.$stateParams.callingPage;
        // let referenceId = this.$stateParams.referenceId;

        // if (!callingPage) {
        //     this.$state.go('tasks', {}, { reaload: true });
        // }
        // else if (callingPage == 'campaign-contact-detail') {
        //     if (this.ApiTasks.campaignContactDetailRedirectParams) {
        //         let campaignId = this.ApiTasks.campaignContactDetailRedirectParams.campaignId;
        //         let contactId = this.ApiTasks.campaignContactDetailRedirectParams.contactId;
        //         this.$state.go('campaignContactDetail', { campaignId: campaignId, contactId: contactId }, { reload: true });
        //     }
        // }
        // else if (callingPage == 'campaign-contacts' && referenceId) {
        //     this.$state.go('campaignDetail', { campaignId: referenceId }, { reload: true });
        // }
        // else if (callingPage == 'campaign-detail' && referenceId) {
        //     this.$state.go('campaignDetail', { campaignId: referenceId }, { reload: true });
        //     // console.log('> refeetail', { campaignId: referenceId }, { reload: true });
        // }
        // else if (callingPage == 'customerInvestorsDetail') {
        //     this.$state.go('customerInvestorsDetail', { investorId: referenceId }, { reload: true });
        // }
        // else if (callingPage == 'investorsDetail') {
        //     this.$state.go('investorsDetail', { investorId: referenceId }, { reload: true });
        // }
        // else if (callingPage == 'tasks') {
        //     this.$state.go('tasks', {}, { reaload: true });
        // }
        this.TaskMutationTrackingService.redirectToStateInSessionStore();
    }

    deleteEvent(task) {
        if (ionic.Platform.isWebView()) {
            const taskCalendar = task.task;
            const taskDeleteStart = new Date(taskCalendar.startDate);
            const taskDeleteEnd = new Date(taskCalendar.dueDate);
            let id = taskCalendar.taskId.toString();
            // taskDeleteStart.setFullYear(taskDeleteStart.getFullYear() - 1);
            // taskDeleteEnd.setFullYear(taskDeleteEnd.getFullYear() + 1);
            // this.$cordovaCalendar.deleteEvent({
            //     title: null,
            //     location: id,
            //     notes: null,
            //     startDate: new Date(taskDeleteStart),
            //     endDate: new Date(taskDeleteEnd)
            // });
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/tasks/taskDetail.controller.js
 **/